export default __webpack_public_path__ + "static/menu-bg2-c478555b4fe02ca1a4d0142dbd23da66.png";